export const ACCOUNT_SETTINGS_PATHS = Object.freeze({
  myDetails: '/account-settings/my-details',
  contactPreferences: '/account-settings/contact-preferences',
  mySubscriptions: '/account-settings/my-subscriptions'
});

/**
 * TODO: these are duplications of cdp-segment consts.
 * They should be removed once cdp-segment is refactored to a monorepo,
 * and we can install its subsequent constants package.
 */
export const SEGMENT_EVENT_NAMES = {
  itemSaved: 'content_saved'
};